import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Sylfaen';
  letter-spacing: .3px; 
 }
 .link{
    text-decoration: none;
 }
 .sublink {
  text-decoration: none;
  color: #614e20ff;
  &:hover {
  transition: all 0.5s ease-in;
  transition: all 0.5s ease-out;
  color: white;
  border-bottom: 2px solid white;
  }
}
`;

export const media = {
  desktop: "@media (min-width:1008px)",
  tablet: "@media (min-width:681px) and (max-width:1007px)",
  mobile: "@media (max-width:680px)",
};

export const MainContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #172029ff;
  color: whitesmoke !important;
`;

export const Header = styled.div`
  width: 100%;
  min-height: 56px;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-top: 2px solid #614e20ff;
  border-bottom: 2px solid #614e20ff;
  background-color: #081019ff;
`;

export const Heading = styled.h1`
  font-size: 18px;
  font-weight: 400;
  color: whitesmoke;
  ${media.mobile} {
    font-size: 16px !important;
  }
`;

export const Button = styled.button`
  background-color: #614e20ff;
  opacity: ${({ variant }) => (variant === "dim" ? "0.7" : "1")};
  color: white;
  border: none;
  padding: ${({ variant }) => (variant === "small" ? "6px 8px" : "8px 10px")};
  font-size: ${({ variant }) =>
    variant === "small" ? "14px" : "15px !important"};
  cursor: pointer;
`;

export default GlobalStyle;
